import api from "../index";

// ** --------- AI Tool API --------- ** //
// Create an ai-tool
export const createAiTool = (values: any) => {
  return api.post("/ai-tool", values);
};

// Get all ai-tools
export const getAllAiTools = () => {
  return api.get("/ai-tools");
};

// Get all ai-tools paginated search
export const getAllAiToolsPaginatedSearch = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/ai-tools/paginated/search?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/ai-tools/paginated/search?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get an ai-tool by ID
export const getAiToolById = (id: any) => {
  return api.get(`/ai-tool/${id}`);
};

// Get an ai-tool by slug
export const getAiToolBySlug = (slug: string) => {
  return api.get(`/ai-tool/by-slug/${slug}`);
};

// Update an ai-tool by ID
export const updateAiToolById = (id: any, values: any) => {
  return api.put(`/ai-tool/${id}`, values);
};

// Delete an ai-tool by ID
export const deleteAiToolById = (id: any) => {
  return api.delete(`/ai-tool/${id}`);
};

// Upload ai-tool image
export const uploadAiToolImage = async (values: any, config: any) => {
  return await api.post(`/ai-tool/image`, values, config);
};

// Update ai-tool approval by ID
export const updateAiToolApprovalById = async (id: any, values: any) => {
  return await api.put(`/ai-tool/approve/${id}`, values);
};

// ** --------- AI Tool Category API --------- ** //
// Create an ai-tool Category
export const createAiToolCategory = async (values: any) => {
  return await api.post("/ai-tool-category", values);
};

// Get all ai-tool Categories
export const getAllAiToolCategories = async () => {
  return await api.get(`/ai-tool-categories`);
};

// Get all ai-tool categories paginated search
export const getAllAiToolsCategoriesPaginatedSearch = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/ai-tool-categories/paginated/search?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/ai-tool-categories/paginated/search?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get an ai-tool Category by id
export const getAiToolCategoryById = async (id: any) => {
  return await api.get(`/ai-tool-category/${id}`);
};

// Get an ai-tool Category by name
export const getAiToolCategoryByName = async (name: string) => {
  return await api.get(`/ai-tool-category/by-name/${name}`);
};

// Update an ai-tool Category by id
export const updateAiToolCategoryById = async (id: any, values: any) => {
  return await api.put(`/ai-tool-category/${id}`, values);
};

// Delete an ai-tool Category by id
export const deleteAiToolCategoryById = async (id: any) => {
  return await api.delete(`/ai-tool-category/${id}`);
};
